import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { KibChewyIcon } from '@chewy/kib-icons-react'
import type { Constant } from '@pbt/pbt-ui-components'

import RxStatusChip from '~/components/common/labels/RxStatusChip'
import { getPrescriptionStates } from '~/store/reducers/constants'
import type { Prescription } from '~/types/entities/prescriptions'

import styles from './RxTrackerTaskHeader.module.scss'

export interface RxTrackerTaskHeaderProps {
  prescription: Prescription
}

const RxTrackerTaskHeader = ({ prescription }: RxTrackerTaskHeaderProps) => {
  const { t } = useTranslation('Common')
  const prescriptionStates = useSelector(getPrescriptionStates) as
    | Constant[]
    | undefined

  return (
    <header className={styles.root}>
      <div className={styles.logoRow}>
        <KibChewyIcon aria-hidden className={styles.chewyIcon} />
        <span>{t('CHEWY_COM')}</span>
      </div>
      <RxStatusChip
        className={styles.statusChip}
        prescription={prescription}
        prescriptionStates={prescriptionStates}
      />
    </header>
  )
}

export default RxTrackerTaskHeader
